<template>
  <div class="BgMomentChart">
    <div class="BgMomentChart__dataset" v-for="d in datasets" v-bind:key="d.id">
      <div v-if="d.data.length > 0">
        <div
          :class="`BgMomentChart__dataset__line ${
            selectedEmotion === d.data[0].emotion && 'active'
          }`"
        ></div>
        <div
          :class="`BgMomentChart__dataset__legend BgMomentChart__dataset__legend--${d.data[0].emotion}`"
        >
          {{ d.label | capitalize }}
        </div>
        <div
          :class="`BgMomentChart__dataset__bubble BgMomentChart__dataset__bubble--${
            bubble.emotion
          } BgMomentChart__dataset__bubble--${
            selected.id === bubble.id ? 'selected' : ''
          }`"
          @click="handleClick(bubble, d.data[0].emotion)"
          v-for="bubble in d.data"
          v-bind:key="bubble.id"
          v-bind:style="{
            width: findWidth(bubble) + '%',
            left: findLeft(bubble) + '%',
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./style.scss";
</style>

<script>
import moment from "moment";
export default {
  name: "BgMomentChart",
  props: ["datasets", "data", "test", "video", "selectedEmotion"],
  data() {
    return {
      startTime: 0,
      endTime: 0,
      length: 0,
      selected: {},
    };
  },
  components: {},
  methods: {
    handleClick(data, emotion) {
      this.selected = data;
      const percentageStart = this.calculateRelativeTime(data.start);
      const percentageEnd = this.calculateRelativeTime(data.end);
      this.$emit(
        "selected",
        data,
        percentageStart,
        percentageEnd,
        data.end - data.start,
        emotion
      );
    },
    findLeft(data) {
      const bubbleStart = moment(data.start);
      const diff = bubbleStart.diff(this.startTime, "milliseconds");
      const percentage = ((diff / 1000) * 100) / this.length;
      return percentage;
    },
    findWidth(data) {
      const bubbleStart = moment(data.start);
      const bubbleEnd = moment(data.end);
      const diff = bubbleEnd.diff(bubbleStart, "milliseconds");
      const percentage = ((diff / 1000) * 100) / this.length;
      return percentage;
    },
    calculateRelativeTime(time) {
      const momentObj = moment(time);
      const difference = momentObj.diff(this.startTime, "milliseconds");
      return difference / 1000 / this.length;
    },
  },
  mounted() {
    this.startTime = moment(this.test.started_at);
    this.endTime = moment(this.test.ended_at);
    this.length = this.endTime.diff(this.startTime, "seconds");
  },
  filters: {
    capitalize: function (value) {
      if (!value) return "";
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
};
</script>
